import { HStack } from '@chakra-ui/react';
import { DsIcon } from '@descomplica/design-system-react';
import { useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';
import styled from 'styled-components';

import envs from '@/infrastructure/config/envs';

import { LogoWrapper } from '../logo/logo-wrapper';
import { AcessibilityMenu } from './acessibility-menu/acessibility-menu';
import DrawerMenu from './drawer-menu/drawer-menu';
import { HeaderViewModel } from './Header.vm';
import HeaderMenu from './header-menu';
import SelectClassifierMenu from './select-classifier-menu/select-classifier-menu';
import { Container, SelectorWrapper, Wrapper } from './styled';

export const AccountLink = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #ffffff;
  padding: 0 16px;
  gap: 16px;
  line-height: 24px;
  letter-spacing: -0.6px;
  word-break: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  cursor: pointer;

  & .ds-icon {
    background-color: white !important;
  }
`;

const Show = styled.div<{ breakpoint: string }>`
  @media screen and ${({ breakpoint }) => breakpoint} {
    display: block;
  }
  display: none;
`;

const Header: React.FC = () => {
  const vm = useViewModel(HeaderViewModel);

  return (
    <Wrapper>
      <Container>
        <SelectorWrapper>
          <LogoWrapper application={vm.application} />
          <Show breakpoint="(min-width: 641px)">
            <SelectClassifierMenu />
          </Show>
        </SelectorWrapper>
        <HeaderMenu />
        <Show breakpoint="(min-width: 768px)">
          <AcessibilityMenu />
        </Show>
        <Show breakpoint="(min-width: 768px)">
          <HStack>
            <AccountLink
              href={envs.recognitionAccountManagementUrl}
              target="_blank"
              rel="noreferrer"
            >
              <DsIcon image="account" />
            </AccountLink>
          </HStack>
        </Show>
        <Show breakpoint="(max-width: 767px)">
          <HStack>
            <DrawerMenu application={vm.application} />
          </HStack>
        </Show>
      </Container>
    </Wrapper>
  );
};

export default Header;
